import React from 'react'
import styled from '@emotion/styled'

const withStyle = (WrappedFunctionEditor) => {
  const StyledFunctionEditor = styled(WrappedFunctionEditor)(
    (props) => `
    `
  )

  return (props) => <StyledFunctionEditor {...props} />
}

export default withStyle
